<div class="add-widgets-modal-content">
    <div class="add-widgets-modal-heading">
        <span class="close-icon" (click)="onCancel()">×</span>
        <img src="./assets/img/lpc-icon-add.svg" alt="+" />
        <h3 class="heading-text">{{ "add" | translate }}</h3>
    </div>

    <div class="tabs">
        <div class="tab" [class.active]="currentTab === 'widget'" (click)="currentTab = 'widget'">
            {{ "control_widget" | translate }}
        </div>
        <div class="tab" [class.active]="currentTab === 'grid'" (click)="currentTab = 'grid'">
            {{ "control_structure" | translate }}
        </div>
    </div>

    @if (currentTab === "widget") {
        <div class="add-widgets-modal-body">
            @let widgets = widgets$ | async;
            @let commonWidgets = widgets | webWidgetGroup: "common";
            @let courseWidgets = widgets | webWidgetGroup: "course";

            @if (commonWidgets.length) {
                <h4 class="widgets-group-title">{{ "widgets_group_common" | translate }}</h4>
                <div class="widgets-list">
                    @for (widget of commonWidgets; track widget) {
                        <web-toolbar-widget
                            [widget]="widget"
                            [eduTariff]="eduUserTariff$ | async"
                            [isAdmin]="isAdmin$ | async"
                            [isEduSite]="isEduSite$ | async"
                            [isDisabledLogoWidget]="isDisabledLogoWidget"
                            (onClick)="onAddWidget(widget)"
                        />
                    }
                </div>
            }

            @if (courseWidgets.length) {
                <h4 class="widgets-group-title">{{ "widgets_group_courses" | translate }}</h4>
                <div class="widgets-list">
                    @for (widget of courseWidgets; track widget) {
                        <web-toolbar-widget
                            [widget]="widget"
                            [eduTariff]="eduUserTariff$ | async"
                            [isAdmin]="isAdmin$ | async"
                            [isEduSite]="isEduSite$ | async"
                            [isDisabledLogoWidget]="isDisabledLogoWidget"
                            (onClick)="onAddWidget(widget)"
                        />
                    }
                </div>
            }
        </div>
    }

    @if (currentTab === "grid") {
        <div class="add-widgets-modal-body">
            <div class="grids-list">
                <web-toolbar-grid (onClick)="onAddGrid($event)" />
            </div>
            <div class="grids-list">
                <web-toolbar-tab
                    [isAdmin]="isAdmin$ | async"
                    [isEduSite]="isEduSite$ | async"
                    (onClick)="onAddTab($event)"
                />
            </div>
        </div>
    }
</div>
